(() => {
  /*
  We are searching for:
    - All users in same ZIP filtered to show those with same last name
    - All users with same Full Name
   */
  var cache = {};

  class FraudCheckController {
    constructor(Users, $scope, $timeout, ngDialog) {
      'ngInject';

      Object.assign(this, {
        Users,
        $scope,
        $timeout,
        ngDialog
      }); // $scope.$on('tab:selected:questions', () => {
      //   this.search();
      // });

      this.similarUsers = 0;
      this.flasePostiveUsers = 0;
      this.firstBold = false;
      this.lastBold = false;
      this.zipBold = false;
      this.stateBold = false;
      this.dobDayBold = false;
      this.dobMonthBold = false;
      this.dobYearBold = false;
      this.ipBold = false;
      this.phoneBold = false;
      this.highlightStateBold = false;
      this.highlightZipBold = false;
      this.highlightPhoneBold = false;
      this.highlightFirstBold = false;
      this.highlightLastBold = false;
      this.falseCheckBoolean = false;
      this.similarCheckBoolean = false;
    }

    $onInit() {
      this.search();
    }

    processLoop(results) {
      var this2 = this;
      var flasePostiveUsers = 0;
      var similarUsers = 0;
      this.userDate = this.patient.dob.substring(0, 10).split("-");

      for (var i = 0; i < results.length; i++) {
        var sameDate = results[i].dob.split("-");
        results[i].dobMonth = sameDate[1];
        results[i].dobYear = sameDate[0];
        results[i].dobDay = sameDate[2];
        this.code = "";

        for (var j = 0; j < results[i].fraud_matches.length; j++) {
          this.code = this.code + "," + results[i].fraud_matches[j].code.split("_");
        }

        var res = this.code.split(",");
        var arr = res.filter(function (item, index, inputArray) {
          return inputArray.indexOf(item) == index;
        });
        arr.shift();
        results[i].firstBold = arr.indexOf("firstname") > -1 ? true : false;
        results[i].lastBold = arr.indexOf("lastname") > -1 ? true : false;
        results[i].zipBold = arr.indexOf("zip") > -1 ? true : false;
        results[i].phoneBold = arr.indexOf("phone") > -1 ? true : false;
        results[i].stateBold = arr.indexOf("state") > -1 ? true : false;
        results[i].dobBold = arr.indexOf("dob") > -1 ? true : false;
        results[i].ipBold = arr.indexOf("IP") > -1 ? true : false;
        results[i].dobDayBold = sameDate[2] == this.userDate[2] ? true : false;
        results[i].dobMonthBold = sameDate[1] == this.userDate[1] ? true : false;
        results[i].dobYearBold = sameDate[0] == this.userDate[0] ? true : false;

        if (!results[i].firstBold) {
          if (this.patient.firstname.toUpperCase() === results[i].firstname.toUpperCase()) {
            results[i].highlightFirstBold = true;
          } else {
            results[i].highlightFirstBold = false;
          }
        }

        if (!results[i].lastBold) {
          if (this.patient.lastname.toUpperCase() === results[i].lastname.toUpperCase()) {
            results[i].highlightLastBold = true;
          } else {
            results[i].highlightLastBold = false;
          }
        }

        if (!results[i].stateBold) {
          if (this.patient.state === results[i].state) {
            results[i].highlightStateBold = true;
          } else {
            results[i].highlightStateBold = false;
          }
        }

        if (!results[i].zipBold) {
          if (this.patient.zip === results[i].zip) {
            results[i].highlightZipBold = true;
          } else {
            results[i].highlightZipBold = false;
          }
        }

        if (!results[i].phoneBold) {
          if (this.patient.cell === results[i].phone) {
            results[i].highlightPhoneBold = true;
          } else {
            results[i].highlightPhoneBold = false;
          }
        }

        if (results[i].false_positive) {
          flasePostiveUsers++;
        } else {
          similarUsers++;
        }
      }

      this2.results = results;
      cache[this.patient.id] = results;
      this2.flasePostiveUsers = flasePostiveUsers;
      this2.similarUsers = similarUsers;
    }

    search() {
      // Check to see if we've ran the check for this user before
      if (cache[this.patient.id]) {
        var results = cache[this.patient.id];
        this.processLoop(results);
        return;
      }

      this.loading = true;
      this.error = false;
      this.Users.search_matchedusers(this.patient.id).then(data => {
        var results = data.data; //cache[this.patient.id] = results;
        this.processLoop(results);
      }).catch(() => {
        this.error = true;
      }).finally(() => {
        this.loading = false;
      });
    }

    getSimilarUsers() {
      return this.similarUsers;
    }

    getFlasePostiveUsers() {
      return this.flasePostiveUsers;
    }

    showFraudCheckDetail() {
      var userId = this.patient.id;
      var patient = this.results;
      this.ngDialog.open({
        templateUrl: 'app/components/fraud-detail/fraud-check-detail.html',
        controller: 'FraudCheckDetailController',
        controllerAs: 'fraudCheck',
        className: 'ngdialog-theme-default check-detail-fraud',
        data: {
          patient,
          userId
        }
      });
    }

  }

  FraudCheckController.$inject = ["Users", "$scope", "$timeout", "ngDialog"];
  angular.module('pims').component('fraudCheck', {
    templateUrl: 'app/components/fraud-check/fraud-check.html',
    controller: FraudCheckController,
    bindings: {
      patient: '<'
    }
  });
})();
